export default __webpack_public_path__ + "static/media/laban-400px.2c5888e4.png";